import { create } from 'zustand';
import { salonsApi } from '../../../api/api';
import type { SalonWithAccessResponse } from '../../../api/generated';

type SalonState = {
  salons: SalonWithAccessResponse[];
  loading: boolean;
  error: string | null;

  // Actions
  loadSalons: () => Promise<void>;
  clearError: () => void;
};

export const useSalonStore = create<SalonState>(set => ({
  salons: [],
  loading: false,
  error: null,

  loadSalons: async () => {
    set({ loading: true, error: null });

    try {
      const response = await salonsApi.getMySalons();
      const salons = response.data;
      set({ salons, loading: false });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Chyba při načítání salonů',
        loading: false,
      });
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));
